/** API route map: URLS.Controller.JobBadges */
export const JobBadges = {
      Name: 'JobBadges/',
      GetJobBadges: 'get-job-badges-list',
      AddJobBadges: 'add-job-badge',
      UpdateJobBadges: 'update-job-badge',
      DeleteJobBadges: 'delete-job-badge',
      SearchBadges: 'search-badges',
      AssignBadges: 'assign-badges',
      GetAllAndAssignedBadges: 'get-all-and-assigned',
      GetAssignedBadges: 'get-assigned-badges',
};
